import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import {
  getCodeData,
  getInitFormData,
  getInitSheet,
  parseDate,
  getTablebySql,
} from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { fnSave } from "@shared/api/restApi";
import SnSheet from "@shared/components/Grid/SnSheet";
import { globalInfo, menuInfo } from "@shared/type/CommonType";
import { showDialog } from "src/widgets/CommonDialog";
import SnResizableLNR from "@shared/components/SnResizableLNR";
import SnButton from "@shared/components/SnButton";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import { IconButton, Tooltip } from "@mui/material";

type AssetItem = {
  cd_pos: string;
  no_line?: number;
  cd_biz?: string;
  cd_item?: string;
  dc_rmk?: string;
  cd_equip?: string;
  cd_matl?: string;
  qt_unit?: number;
};

interface Props {
  Menuprops: menuInfo;
  PkFields: string[]; // PK 필드 목록
  tableName: string; // 저장할 테이블 이름
  controllerName: string; // 저장할 API 컨트롤러 이름
  userInfo: globalInfo["userInfo"];
}

const SN_PRD_BAS_REG_014_POP_01 = forwardRef(
  (
    { Menuprops, PkFields, tableName, controllerName, userInfo }: Props,
    ref
  ) => {
    const [columns, setColums] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any>();
    const gridref1 = useRef<any>(null);

    //#region grid 길이 관련
    let width1 = "99%";
    const menuSize = localStorage.getItem("menuSize");
    if (menuSize) {
      const menu = JSON.parse(menuSize);
      if (menu.ExcelUpload) {
        width1 = menu.ExcelUpload.grid1Width
          ? menu.ExcelUpload.grid1Width
          : width1;
      }
    }
    const [grid1Width, setGrid1Width] = useState<string | number>(width1);

    const [compareFields, setCompareFields] = useState<string[]>(PkFields); // 비교할 필드를 상태로 저장
    const [codeDataList, setCodeDataList] = useState<Record<string, string>[]>(
      []
    ); // 비교 대상 테이블 data tableName

    const [itemMap, setItemMap] = useState<Map<string, AssetItem>>(new Map());
    const loadItemList = async () => {
      const itemList = await getCodeData(tableName, "");
      const map = new Map<string, any>();
      itemList.forEach((item: { cd_item: string; cd_equip: string }) => {
        const key = `${item.cd_item}||${item.cd_equip}`;
        map.set(key, item);
      });
      setItemMap(map);
    };
    //  tableName list

    //  메뉴에서 `cd_clas`, `cd_popup` 데이터를 한 번만 로드
    const [codeDataMap, setCodeDataMap] = useState(new Map());
    const [popupDataMap, setPopupDataMap] = useState(new Map());

    //#endregion

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitSheet({});

          // 오류내용 칼럼 수동 추가
          rtn.grid.sheet1.push({
            cd_column: "error_msg",
            nm_column: "오류내용",
            qt_width: 200,
            tp_column: "text",
            fg_visible: "Y",
            yn_required: "N",
            dc_editcon: "1 == 1",
            editable: false, // 수정 불가
          });

          setColums(rtn.grid.sheet1);

          gridref1.current.resetGridData();
        } catch (error) {}
      };
      fetchform();
      loadItemList();
    }, []);

    // useEffect(() => {
    //   if (gridref1.current) {
    //     gridref1.current.setCodeDataList(codeDataList); //  SnSheet 내부에서 코드 데이터 갱신 메서드 실행
    //   }
    // }, [codeDataList]); //  codeDataList가 변경될 때마다 실행

    const onDelete = () => {
      const focusedCell = gridref1.current.api.getFocusedCell();
      let startRowIndex = focusedCell.rowIndex ?? 0;

      gridref1.current?.deleteRowByIndex(startRowIndex);
    };

    const normalizeDate = (val: string) => val?.replace(/[-/]/g, "");

    const onSave = async () => {
      try {
        const insertList: any[] = [];
        const deleteList: any[] = [];

        gridref1.current.api.forEachNode((node: { data: any }) => {
          const row = node.data;

          // 1. 빈 줄은 스킵
          const isEmptyRow = ["cd_matl", "cd_item", "cd_pos"].every(
            (field) => !row[field]
          );
          if (isEmptyRow) return;

          const saveRow = {
            ...row,
            cd_biz: userInfo.cd_biz,
            cd_firm: userInfo.cd_firm,
          };
          const key = `${saveRow.cd_item}||${saveRow.cd_equip}`;
          if (itemMap.has(key)) {
            // 기존 no_line 등 PK를 백엔드에서 delete 할 때 필요하다면 같이 보내줌
            deleteList.push({
              cd_firm: userInfo.cd_firm,
              cd_item: saveRow.cd_item,
              cd_equip: saveRow.cd_equip,
            });
          }
          insertList.push(saveRow);
        });

        for (const row of deleteList) {
          const sqlQuery = {
            sql: "delete from prd_putitem_pos where cd_firm = :cd_firm and cd_item = :cd_item and cd_equip = :cd_equip",
            cd_firm: userInfo.cd_firm,
            cd_item: row.cd_item,
            cd_equip: row.cd_equip,
          };
          await getTablebySql(sqlQuery);
        }

        const SaveData: any = {};
        SaveData[tableName] = {
          delete: [],
          insert: insertList,
          update: [], // update는 사용 안 함
          modifiedRowcount: insertList.length,
        };

        // 3️⃣ 변경 없으면 종료
        if (insertList.length === 0 && deleteList.length === 0) {
          await showDialog("alert", "변경된 내용이 없습니다.");
          return;
        }
        await fnSave(controllerName, SaveData);
        gridref1.current.resetUpdate();
        gridref1.current.resetGridData();
      } catch (error: any) {}
    };
    // grid1의 width resize
    const onResizeStopH = (width: number) => {
      setGrid1Width(width);
    };

    useImperativeHandle(ref, () => ({
      onDelete,
      onSave,
    }));

    const isEmptyRow = (row: any): boolean => {
      const checkFields = ["cd_matl", "cd_item", "cd_pos"];
      return checkFields.every((field) => !row[field]);
    };

    const Validation = async (): Promise<boolean> => {
      //  Validation 실행하여 오류 체크

      const validDateRegex =
        /^(19|20)\d{2}(\/|-)?(0[1-9]|1[0-2])(\/|-)?(0[1-9]|[12][0-9]|3[01])$/;

      if (gridref1.current.api.getDisplayedRowCount() <= 1) {
        await showDialog("alter", "처리할 내용이 없습니다.");
        return true;
      }

      let hasError = false;
      gridref1.current.api.forEachNode((node: any) => {
        const row = node.data;
        if (!row || isEmptyRow(row)) return;
        let errorMsg = "";

        gridref1.current.api
          .getRowNode(node.id)
          .setDataValue("error_msg", errorMsg);
      });
      //   const isValid = await gridref1.current.validateData();

      if (hasError) {
        showDialog("error", "오류내역을 확인해주세요.");
        return false;
      } else {
        return true;
      }
    };

    const onGrid1BtnsClick = async (id: string) => {
      if (id == "aButton_Init") {
        gridref1.current.resetGridData();
      }

      if (id == "aButton_Validation") {
        const isValid = await Validation();
        if (isValid) {
          showDialog("alter", "오류가 없습니다.");
        }
      }
    };

    return (
      <div className="h-full flex flex-col">
        <div className="w-full flex flex-row space-x-2 flex-grow overflow-x-auto">
          <SnResizableLNR
            width={grid1Width}
            minWidth={130}
            onResizeStop={onResizeStopH}
            enable={{ right: true }}
            menuName={Menuprops.cd_menu ?? ""}
            defaultSize={{ grid2Width: grid1Width }}
          >
            <SnSheet
              ref={gridref1}
              enableAddRow={true}
              columnConfig={columns}
              rowData={dataSource1}
              isEditable={true} // 수정 가능여부
              codeDataList={codeDataList} // pk 체크용 데이터 전달
              compareFields={compareFields} // 비교할 필드 정보 전달
              title={Menuprops.nm_menu}
              header={
                <div>
                  <SnButton
                    text={"초기화"}
                    onClick={() => {
                      onGrid1BtnsClick("aButton_Init");
                    }}
                  />
                  <SnButton
                    text={"오류체크"}
                    onClick={() => {
                      onGrid1BtnsClick("aButton_Validation");
                    }}
                  />
                  <Tooltip title="Save">
                    <IconButton
                      onClick={onSave}
                      sx={{
                        color: "gray", // 기본 색상
                        "&:hover": {
                          color: "blue", // hover 시 색상
                          transform: "scale(1.2)", // hover 시 크기 확대
                          transition: "all 0.3s ease", // 부드러운 애니메이션
                        },
                      }}
                    >
                      <SaveIcon />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Delete">
                    <IconButton
                      onClick={onDelete}
                      sx={{
                        color: "gray", // 기본 색상
                        "&:hover": {
                          color: "blue", // hover 시 색상
                          transform: "scale(1.2)", // hover 시 크기 확대
                          transition: "all 0.3s ease", // 부드러운 애니메이션
                        },
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              }
            />
          </SnResizableLNR>
        </div>
      </div>
    );
  }
);

export default SN_PRD_BAS_REG_014_POP_01;
